module.exports = __webpack_public_path__ + "img/tell2.fe5f39df.svg";